module.exports = __webpack_public_path__ + "img/enerman-etisol_new2.85542124.svg";